'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Events = {
  RECEIVED_MESSAGES: 'received-messages',
  RECEIVED_CHATS: 'received-chats',
  RECEIVED_STATUS: 'received-status',
  INTERNAL_ERROR: 'internal-error',
  XMPP_ERROR: 'error',
  ONLINE: 'online',
  RECONNECTING: 'reconnecting',
  STANZA: 'stanza',
  SENDING: 'sending',
  VALIDATE_PROFILE: 'validate-profile'
};
var UserStatus = {
  START_TYPING: 'start-typing',
  STOP_TYPING: 'stop-typing'
};
var MessageStatus = {
  SENDING: 'sending',
  SENT: 'sent',
  RECEIVED: 'received',
  READ: 'read',
  ERROR: 'error'
};
var XMPPConnectionEvents = ['online', 'offline', 'connecting', 'connect', 'opening', 'open', 'closing', 'close', 'disconnecting', 'disconnect', 'error'];
var XMPPReconnectionEvents = ['reconnecting', 'reconnected', 'error'];
var XMPPOnlineEvents = ['online', 'connecting', 'connect', 'opening', 'open', 'reconnecting', 'reconnected'];
exports.Events = Events;
exports.UserStatus = UserStatus;
exports.MessageStatus = MessageStatus;
exports.XMPPConnectionEvents = XMPPConnectionEvents;
exports.XMPPReconnectionEvents = XMPPReconnectionEvents;
exports.XMPPOnlineEvents = XMPPOnlineEvents;